export enum NoticeStatusType {
    NA = 0,
    Pending = 1,
    Generated = 2,
    Emailed = 3,
    Error = 4,
}
